import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ConfigState {
  borneId: string;
  borneName: string;
  adminPin: string;
  isConfigured: boolean;
  screensaverTimeout: number;
  screensaverImages: string[];
  maxTickets: number;
  ticketsPrinted: number;

  setConfig: (partial: Partial<Pick<ConfigState,
    'borneId' | 'borneName' | 'adminPin' | 'screensaverTimeout' | 'screensaverImages' | 'maxTickets'
  >>) => void;
  reset: () => void;
  incrementTicket: () => number;
  resetTickets: () => void;
  isTicketLimitReached: () => boolean;
}

const DEFAULTS = {
  borneId: '',
  borneName: '',
  adminPin: '1234',
  isConfigured: false,
  screensaverTimeout: 30,
  screensaverImages: [] as string[],
  maxTickets: 999,
  ticketsPrinted: 0,
};

export const useConfigStore = create<ConfigState>()(
  persist(
    (set, get) => ({
      ...DEFAULTS,

      setConfig: (partial) =>
        set((state) => {
          const next = { ...state, ...partial };
          return {
            ...partial,
            isConfigured: next.borneId !== '',
          };
        }),

      reset: () => set(DEFAULTS),

      incrementTicket: () => {
        const next = get().ticketsPrinted + 1;
        set({ ticketsPrinted: next });
        return next;
      },

      resetTickets: () => set({ ticketsPrinted: 0 }),

      isTicketLimitReached: () => {
        const { ticketsPrinted, maxTickets } = get();
        return ticketsPrinted >= maxTickets;
      },
    }),
    {
      name: 'borne-config',
      partialize: (state) => ({
        borneId: state.borneId,
        borneName: state.borneName,
        adminPin: state.adminPin,
        screensaverTimeout: state.screensaverTimeout,
        screensaverImages: state.screensaverImages,
        maxTickets: state.maxTickets,
        ticketsPrinted: state.ticketsPrinted,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.isConfigured = state.borneId !== '';
        }
      },
    },
  ),
);
